import React from "react";
import Login from "../../components/admin/login/Login";

const LoginPage = () => {
  return (
    <>
      <Login />
    </>
  );
};

export default LoginPage;
